<div class="date">
    <common-date-picker [(ngModel)]="fromDate" (ngModelChange)="onChangeFromOrTo()" [disabled]="disabled"></common-date-picker>
    <span>-</span>
    <common-date-picker [(ngModel)]="toDate" (ngModelChange)="onChangeFromOrTo()" [disabled]="disabled"></common-date-picker>
</div>
